import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useOnclickOutside from 'react-cool-onclickoutside';
import { DropdownContainer, DropdownText } from '../../common/dropdown/styles';
import sortOrders from './constants';
import {
  buildOption,
  SDropdownIcon,
  SOptionsContainer,
} from './common';

const Container = styled.div`
  z-index: 2;
`;

export default function Desktop({
  sortOrder,
  setSortOrder,
  showOptions,
  toggleShowOptions,
}) {
  const { name, order } = _.find(sortOrders, { slug: sortOrder }) || {};
  const sortOrderLabel = _.compact([name, order]).join('');

  // eslint-disable-next-line no-nested-ternary
  const className = showOptions ? 'focus' : sortOrder === 'default' ? '' : 'active';

  const ref = useOnclickOutside(() => showOptions && toggleShowOptions());

  return (
    <Container ref={ref}>
      <DropdownContainer className={className} onClick={toggleShowOptions}>
        <SDropdownIcon className="icon-lw icon-lw-sort" />
        <DropdownText>{sortOrderLabel}</DropdownText>
      </DropdownContainer>
      {showOptions && (
        <SOptionsContainer>
          {sortOrders.map(o => buildOption({ ...o, sortOrder, onClick: setSortOrder }))}
        </SOptionsContainer>
      )}
    </Container>
  );
}

Desktop.propTypes = {
  sortOrder: PropTypes.string.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  showOptions: PropTypes.bool.isRequired,
  toggleShowOptions: PropTypes.func.isRequired,
};
